import { render, staticRenderFns } from "./CenterCard.vue?vue&type=template&id=949162d2&scoped=true&"
import script from "./CenterCard.vue?vue&type=script&lang=js&"
export * from "./CenterCard.vue?vue&type=script&lang=js&"
import style0 from "./CenterCard.vue?vue&type=style&index=0&id=949162d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949162d2",
  null
  
)

export default component.exports